import {useRootSelector} from 'store';

export function useProject(id: string) {
  const project = useRootSelector((state) => {
    return state.projects.entities[id] || null;
  });

  return {project, id, loading: !project && id !== 'new'};
}
